import React, {PureComponent} from 'react';
import injectSheet from 'react-jss'
import cn from 'classnames'
import {connect} from "react-redux"
import CentredContentContainer from "../Widgets/CentredContentContainer"
import {getGlobalContent} from "../../selectors"
import NewsletterFormPageStyle from './NewsletterFormPageStyle'
import BackgroundContrastContainer from '../LandingPage/BackgroundContrastContainer'

class Newsletter extends PureComponent {

    componentDidMount() {}

    render() {
        const {classes, submitted, global} = this.props;
        const {newsletter_subscription_title, newsletter_subscription_promotion, newsletter_subscription_post_message} = global;

        return (
          <BackgroundContrastContainer className={classes.root} dataCy="newsletterSection" applyContrast>
            <CentredContentContainer className={classes.newsletterContainer}>
              <h2 className={classes.title}>{newsletter_subscription_title}</h2>
              <div className={classes.copy} dangerouslySetInnerHTML={{__html: newsletter_subscription_promotion}}/>
              {submitted && <div className={cn(classes.message)} dangerouslySetInnerHTML={{__html: newsletter_subscription_post_message}}/> }
              {!submitted && (
                <NewsletterFormPageStyle
                  classNames={{
                      dropDown: classes.dropDown
                  }}
                  submitText='Subscribe'
                />
              )}
            </CentredContentContainer>
          </BackgroundContrastContainer>
        );
    }
}

function mapStateToProps(state) {
    return {
        global: getGlobalContent(state),
        submitted: state.scenes.form.newsletter.isSubmitted ||
            state.scenes.form['newsletter-footer'].isSubmitted
    }
}

export default injectSheet((theme) => ({
      root: {
        minHeight: 100,
        position: "relative",
        textAlign: 'center',
        padding: '2.8rem 0'
      },
      title: {
        textTransform: 'initial',
        fontSize: theme.getRemValue(20),
        marginBottom: 8,
        [theme.breakpoint('tablet')]: {
          textTransform: 'uppercase'
        }
      },
      copy: {
        '& p': {
          fontSize: theme.getRemValue(16),
          marginBottom: '1rem',
          [theme.breakpoint('tablet')]: {
            marginBottom: '2rem'
          }
        }
      },
      newsletterContainer: {
        display: 'block',
        padding: '0 2rem'
      },
      message: {
        composes: '$copy',
        textAlign: 'center',
        color: theme.colors.subTitle,
        '& p:last-child': {
          marginBottom: 0
        }
      },
      dropDown: {
        minWidth: 150,
        [theme.breakpoint("tablet")]: {
          minWidth: 180,
        },
        [theme.breakpoint("tablet")]: {
          minWidth: 200,
        }
      }
  }
))(connect(mapStateToProps)(Newsletter));



// WEBPACK FOOTER //
// ./src/components/Newsletter/Newsletter.js